const ipForm = {
  title: () => 'italist | Intellectual property rights feedback',
  description: () =>
    "We have an extensive vetting process to ensure that we only offer genuine luxury goods, but if you have any concerns regarding a product's authenticity, please let us know here.",
};

export default ipForm;
